import VCounter from './VCounter'

export { VCounter }
export default VCounter



// WEBPACK FOOTER //
// ../../../src/components/VCounter/index.ts